import FigmaBadge from '../Elements/FigmaBadge';
import React from 'react';
import ExcludedAssignmentItem from './ExcludedAssignmentItem';
import LongText from '../Elements/LongText';

export default class ExcludedAssignmentClientItem extends ExcludedAssignmentItem {
  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        <FigmaBadge
          Active={item}
          ActiveText='Yes'
          InactiveText='No'
          width={50}
        />
      </div>
    );
  }
  static FieldsToShowInDataTable() {
    return [
      {
        label: ExcludedAssignmentClientItem.getSelectedCellHeader,
        orderById: '',
        data: ExcludedAssignmentClientItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_excludedassignmentselect',
      },
      { label: 'Apollo Id', orderById: 'AsSassieAsgnId', data: ExcludedAssignmentItem.idFunction },
      { label: 'Client', orderById: 'ClientName', data: 'ClientName', minWidth: 50 },
      {
        label: 'Project',
        orderById: 'AsCfid',
        data: (item) => (
          <LongText
            text={item.ProjectIdAndName}
            maxLength={30}
          />
        ),
        minWidth: 100,
      },
      { label: 'Location', orderById: 'CuName', data: 'CuName', minWidth: 250 },
      { label: 'Eval Fee Total', orderById: 'FeeTotal', data: 'FeeTotal', minWidth: 80 },
      { label: 'Eval Reimb. Total', orderById: 'ReimbTotal', data: 'ReimbTotal', minWidth: 80 },
      { label: 'FW Office', orderById: 'AsLdvname', data: 'AsLdvname' },
      { label: 'FW Fee', orderById: 'InFieldworkFeeWithSymbol', data: 'InFieldworkFeeWithSymbol', minWidth: 80 },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname' },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 70 },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDateFormatted',
        data: 'AsEvaluatorCompletedDateFormatted',
        minWidth: 90,
      },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 55 },
      {
        label: 'Uninv.',
        orderById: 'AsUninvoiceable',
        data: (item) => ExcludedAssignmentClientItem.getIsActiveCellContent(item.AsUninvoiceable),
        minWidth: 35,
      },
    ];
  }
  static selectedStatus() {
    return true;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={ExcludedAssignmentClientItem.selectedStatus()}
          onChange={(e) => {
            ExcludedAssignmentClientItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            ExcludedAssignmentClientItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
}
